import 'bulma/css/bulma.css'
import './index.css'
import 'core-js/stable'
import 'regenerator-runtime'
import './app'
